import axios from "axios";
import { getUserAccessToken } from "../user";

export const getNotifications = async () => {
  try {
    let token = await getUserAccessToken();
    //let obj = await axios.get(`${window._env.REACT_APP_EMCONSOLE_API_URL}/v1/csrftoken`)
      let headers = {
          headers: {
              'Authorization': `Bearer ${token}`,
              // "csrfToken":obj.data.csrfToken,
              "X-Frame-Options":"sameorigin",
              "strict-transport-security": "max-age=31536000; includeSubDomains",
              "X-XSS-Protection":"1; mode=block",
              "x-content-type-options":"nosniff",
              "X-Download-Options":"noopen",
              "Content-Security-Policy":"policy"                        
            }
      }
    let { data } = await axios.get(`${window._env.REACT_APP_EMCONSOLE_API_URL}/v1/notifications`, headers);
    return data;
  } catch (e) {
    console.log(e)
  }
};
